import { styled } from '@mui/material/styles'
import * as React from 'react'
// import { RaBox } from 'ra-compact-ui';
import { Typography } from 'antd'
import { LockedFeature } from './LockedFeature'

const PREFIX = 'SettingsGroup'

const classes = {
  settingsGroup: `${PREFIX}-settingsGroup`,
}

const Container = styled('div')(({ theme }) => ({
  [`&.${classes.settingsGroup}`]: {
    marginBottom: '50px',
  },
}))

type SettingsGroupProps = {
  className: string;
  name: string;
  locked: boolean;
  description: string;
}

export const SettingsGroup: React.FC<SettingsGroupProps> = (props) => {
  const { className, name, locked, description, children, ...rest } = props

  const childrenWithProps = React.Children.map(children, (child) => {
    // checking isValidElement is the safe way and avoids a typescript error too
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...rest })
    }
    return child
  })

  return (
    <Container
      style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
      className={classes.settingsGroup}
    >
      <div style={{ marginRight: 20, width: '50%' }}>
        <h3
          style={{
            lineHeight: 1.5,
            margin: 0,
          }}
        >
          {name}
          {locked ? <LockedFeature /> : null}
        </h3>
        <Typography.Text type="secondary">{description}</Typography.Text>
      </div>
      <div style={{ width: 750 }}>{childrenWithProps}</div>
    </Container>
  )
}
